import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "rgba(243, 244, 251, 1)",
    color: "rgba(86, 99, 202, 1)",
    fontSize: "16px",
    fontWeight: "600",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    color: "rgba(19, 19, 19, 1)",
    border: 0,
  },
}));

const StyledTableRow = styled(TableRow)(() => ({
  "&:nth-of-type(odd)": { backgroundColor: "rgba(220, 222, 243, 0.1)" },
  "&:nth-of-type(even)": { backgroundColor: "rgba(220, 222, 243, 0.35)" },
}));
export default function TableRatings({ ratings = [] }) {
  const [page, setPage] = useState(0);
  const rowsPerPage = 10;
  const handleChangePage = (_, newPage) => setPage(newPage);

  const paginatedRatings = (ratings || []).slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <>
      <TableContainer>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>#</StyledTableCell>
              <StyledTableCell>Имя</StyledTableCell>
              <StyledTableCell>Сделок на</StyledTableCell>
              <StyledTableCell align="right">Количество</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedRatings.length > 0 ? (
              paginatedRatings.map((item, index) => (
                <StyledTableRow key={index}>
                  <StyledTableCell>
                    {page * rowsPerPage + index + 1}
                  </StyledTableCell>
                  <StyledTableCell>{item.name}</StyledTableCell>
                  <StyledTableCell>{item.deals_on}</StyledTableCell>
                  <StyledTableCell align="right">
                    {item.number_of_sales}
                  </StyledTableCell>
                </StyledTableRow>
              ))
            ) : (
              <StyledTableRow>
                <StyledTableCell colSpan={4} align="center">
                  Нет данных
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {ratings && ratings.length > 0 && (
        <TablePagination
          rowsPerPageOptions={[]}
          component="div"
          count={ratings.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
        />
      )}
    </>
  );
}
